import { SvgIcon, SvgIconProps } from '@mui/material';

// Inline SVG (currentColor) instead of <img src> so the icon stays vector, not rasterized.
export const OrganizationMenuIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 26 26">
    <path
      d="M14.1 11.7778H19.38C20.6121 11.7778 21.2282 11.7778 21.6988 12.0442C22.1127 12.2785 22.4493 12.6525 22.6602 13.1124C22.9 13.6353 22.9 14.3199 22.9 15.6889V24M14.1 24V5.91111C14.1 4.5421 14.1 3.85758 13.8602 3.33469C13.6493 2.87473 13.3127 2.50078 12.8988 2.26643C12.4282 2 11.8121 2 10.58 2H6.62C5.38789 2 4.77182 2 4.30122 2.26643C3.88726 2.50078 3.5507 2.87473 3.33979 3.33469C3.1 3.85758 3.1 4.5421 3.1 5.91111V24M24 24H2M6.95 6.88889H10.25M6.95 11.7778H10.25M6.95 16.6667H10.25"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default OrganizationMenuIcon;
